import { BaseVendorFacade } from './BaseVendorFacade';
export class VendorExternalMerchantFacade extends BaseVendorFacade {
    constructor() {
        super(...arguments);
        this.baseUrl = (merchantId) => `api/v2/merchants/${encodeURIComponent(merchantId)}/external-merchants`;
    }
    async retrieve(merchantId, externalMerchantId, expand) {
        return (await this.client.get(`${this.baseUrl(merchantId)}/${encodeURIComponent(externalMerchantId)}`, {
            params: { expand },
        })).data;
    }
}
//# sourceMappingURL=VendorExternalMerchantFacade.js.map